import { render, staticRenderFns } from "./integral-task.vue?vue&type=template&id=7f357de3&"
import script from "./integral-task.vue?vue&type=script&lang=js&"
export * from "./integral-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports